import React from 'react'
import StoreRoutes from './routes';
import { Provider } from 'react-redux';
import globalStore from '../../store';

const StoreApp = () => (
    <Provider store={globalStore}>
        <StoreRoutes />
    </Provider>
)

export default StoreApp
